import { getAuthAxios } from "@artprov/design-system";

const paths = {
  getAll: "tipoAutorizacionAfip"
};

export const getOpcionesTipoCaeCai = async () => {
  const response = await getAuthAxios("default").get(paths.getAll);
  return response;
};